import { ActivityIndicator, Image, Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { MainNavProps } from './navigation/main/MainParamList';
import React, { useEffect, useRef, useState } from 'react';
import Video, { OnLoadData, OnProgressData, OnVideoErrorData, VideoRef } from 'react-native-video';
import { black, white } from '../assets/style/colors';
import type { OnBufferData } from 'react-native-video/src/specs/VideoNativeComponent';
// Immerse related imports removed for web compatibility
import { useIsFocused } from '@react-navigation/native';
import { ImageView } from '../components/ImageView';
import { saveAsset, saveVideoToPhoto } from '../utils/FileUtils';
import BaseScreen from './BaseScreen';
import Slider from '@react-native-community/slider';
import { secondsToHms } from '../utils/date';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import FastImage from 'react-native-fast-image';
import { findCachePath, downloadFile } from '../utils/downloadFile';
import RNFS from 'react-native-fs';
import { requestImage } from '../utils/RequestPermission';
import globalEventBus from '../utils/EventBus';
import { index } from 'realm';
import { showToast } from '../components/Toast';

let format: string = 'mm:ss';

export function VideoScreen({ navigation, route }: MainNavProps<'VideoScreen'>) {
	const videoUrl = route.params.item.content || '';
	const localPath = route.params.item.upload_path || '';
	const thumbnailPath = route.params.item.thumbnailPath || '';
	const myIndex = route.params.item.index || 0;
	let isHadInit = false;
	const currentIndex = useRef<number>(route.params.item.currentIndex);
	const videoRef = useRef<VideoRef>(null);
	const [isPause, setIsPause] = useState(true);
	const [isBuffering, setIsBuffing] = useState(true);
	const [sliderValue, setSliderValue] = useState(0);
	const [duration, setDuration] = useState<number>();
	const [curTime, setCurTime] = useState(0);
	const insets = useSafeAreaInsets();
	const isFocused = useIsFocused();
	const [url, setUrl] = useState(localPath && localPath.length > 0 ? localPath : videoUrl);
	const loaclLoadError = useRef<boolean>(localPath.length > 0);
	const [isNetworkUrl, setIsNetworkUrl] = useState<boolean>(false);
	const [isVideoLoaded, setIsVideoLoaded] = useState<boolean>(false);
	const [key, setKey] = useState<number>(0); // 用于强制重新加载视频
	const errorRetryCount = useRef<number>(0);
	const maxRetries = 3;

	// 初始化视频URL，优先使用缓存
	useEffect(() => {
		// console.log('\n-----onViewableItemsChanged11111111', `  ${myIndex}`);
		if (isHadInit === false && myIndex === currentIndex.current && (videoUrl.length !== 0 || localPath.length !== 0)) {
			// console.log('\n-----onViewableItemsChanged222222', `  ${myIndex}`);
			initVideoUrl();
		}
	}, [videoUrl, localPath, myIndex]);

	useEffect(() => {
		if (isFocused) {
			// Immerse related code removed for web compatibility
			// console.log('-----onViewableItemsChanged33333', `  ${myIndex}`);

		const handleViewableItemsChanged = (data: any) => {
			currentIndex.current = data.index;
			if (isHadInit === false && Math.abs(myIndex - data.index) === 1) {
				initVideoUrl();
				return;
			}

			data.index !== myIndex ? pause() : play();
		};
		
		globalEventBus.on('onViewableItemsChanged', handleViewableItemsChanged);
		
		return () => {
			globalEventBus.off('onViewableItemsChanged', handleViewableItemsChanged);
		};
	}
	// Immerse related cleanup removed for web compatibility
}, [isFocused]);

	const initVideoUrl = async () => {
		if (isHadInit) {
			return;
		}
		isHadInit = true;

		// console.log('======initVideoUrl： ');
		// 重置状态
		setIsVideoLoaded(false);
		setDuration(undefined);
		setCurTime(0);
		setSliderValue(0);
		setIsBuffing(true);
		errorRetryCount.current = 0;

		// 如果有本地路径，优先使用本地路径
		if (localPath && localPath.length > 0) {
			setUrl(localPath);
			loaclLoadError.current = false;
			setKey((prev) => prev + 1); // 强制重新加载
			return;
		}

		// 如果是网络URL，检查是否有缓存
		if (videoUrl && (videoUrl.startsWith('http://') || videoUrl.startsWith('https://'))) {
			setIsNetworkUrl(true);
			try {
				const cacheResult = await findCachePath(videoUrl, 'video');
				if (cacheResult.isCache) {
					// 检查缓存文件是否有效（文件大小大于0）
					try {
						const exists = await RNFS.exists(cacheResult.url);
						if (exists) {
							const stat = await RNFS.stat(cacheResult.url);
							if (stat.size > 0) {
								// 使用缓存文件
								setUrl(cacheResult.url);
								setIsNetworkUrl(false);
								setKey((prev) => prev + 1); // 强制重新加载
								console.log('使用缓存的视频:', cacheResult.url);
								return;
							} else {
								console.log('缓存文件为空，使用网络URL');
								setUrl(videoUrl);
								setIsNetworkUrl(true);
								setKey((prev) => prev + 1);
							}
						}
					} catch (e) {
						console.log('检查缓存文件失败:', e);
						setUrl(videoUrl);
						setIsNetworkUrl(true);
						setKey((prev) => prev + 1);
					}
				}
				// 使用网络URL
				setUrl(videoUrl);
				setKey((prev) => prev + 1); // 强制重新加载
			} catch (error) {
				console.log('检查视频缓存失败:', error);
				setUrl(videoUrl);
				setKey((prev) => prev + 1); // 强制重新加载
			}
		} else {
			setUrl(videoUrl);
			setIsNetworkUrl(false);
			setKey((prev) => prev + 1); // 强制重新加载
		}
	};

	const onClick = () => {
		if (isPause) {
			play();
		} else {
			pause();
		}
	};

	function play() {
		setIsPause(false);
		videoRef.current?.resume();
		// 播放时隐藏缓冲指示器（如果视频已加载）
		if (duration) {
			setIsBuffing(false);
		}
	}

	function pause() {
		setIsPause(true);
		videoRef.current?.pause();
	}

	function onEnd() {
		// 只在视频已加载完成时 seek，避免 -11880 错误
		if (isVideoLoaded && duration) {
			try {
				videoRef.current?.seek(0);
				setSliderValue(0);
				setCurTime(0);
			} catch (e) {
				console.log('seek 失败:', e);
			}
		}
		pause();
	}

	function onLoad(e: OnLoadData) {
		if (!duration) {
			const d = e.duration;
			// 检查 duration 是否有效
			if (d && d > 0 && isFinite(d)) {
				format = d >= 3600 ? 'hh:mm:ss' : 'mm:ss';
				setDuration(d);
				setIsVideoLoaded(true);
				// 视频加载成功后，停止显示缓冲指示器
				setIsBuffing(false);
				errorRetryCount.current = 0; // 重置错误计数

				// 如果当前使用的是网络URL，在后台开始完整下载到自定义缓存
				// 这样下次播放时可以直接使用完整缓存，提升体验
				// 注意：react-native-video 的 shouldCache 已经实现了边下载边播放
				// 这里是在后台完整下载，以便下次离线使用
				if (url && url.startsWith('http') && videoUrl && videoUrl.startsWith('http')) {
					// 延迟一下再开始下载，避免影响播放
					setTimeout(() => {
						findCachePath(videoUrl, 'video')
							.then((cacheResult) => {
								// 只有当缓存不存在时才下载
								if (!cacheResult.isCache) {
									downloadFile(videoUrl, 'video')
										.then((cachedPath) => {
											if (cachedPath && cachedPath !== videoUrl) {
												console.log('视频已完整缓存到:', cachedPath);
											}
										})
										.catch((err) => {
											console.log('后台下载视频失败:', err);
										});
								}
							})
							.catch((err) => {
								console.log('检查缓存失败:', err);
							});
					}, 2000); // 延迟2秒，确保视频已经开始流畅播放
				}
			} else {
				console.log('视频 duration 无效:', d);
				// duration 无效，触发错误处理
				onError({
					error: {
						code: -1,
						domain: 'VideoLoadError',
						localizedDescription: '视频 duration 无效',
					},
					target: 0,
				} as OnVideoErrorData);

				showToast('load Video Error, video duration Invalid');
			}
		}
	}

	function onValueChange(value: number) {
		if (duration) {
			const seek = value * duration;
			setCurTime(seek);
		}
	}

	function onSlidingComplete(value: number) {
		// 只在视频已加载完成时 seek，避免 -11880 错误
		if (isVideoLoaded && duration) {
			const seek = Math.max(0, Math.min(value * duration, duration));
			try {
				videoRef.current?.seek(seek);
				setCurTime(seek);
			} catch (e) {
				console.log('seek 失败:', e);
			}
		}
	}

	function onProgress(e: OnProgressData) {
		setCurTime(e.currentTime);
		if (duration) {
			setSliderValue(e.currentTime / duration);
		}
	}

	function close() {
		videoRef.current?.pause();
		navigation.goBack();
	}

	function onBuffer(e: OnBufferData) {
		setIsBuffing(e.isBuffering);
		// 如果正在缓冲且视频已经加载，减少缓冲指示器的显示时间
		if (!e.isBuffering && duration) {
			// 缓冲结束，确保不显示缓冲指示器
			setTimeout(() => {
				setIsBuffing(false);
			}, 100);
		}
	}

	function onError(e: OnVideoErrorData) {
		console.log('视频加载错误:', e);
		const errorCode = e.error?.code;
		const errorDomain = e.error?.domain;
		const localizedDescription = e.error?.localizedDescription;

		// iOS 错误 -11880: 无效的采样光标
		// 这通常发生在视频文件不完整、损坏或 seek 到无效位置时
		if (errorDomain === 'AVFoundationErrorDomain' && errorCode === -11880) {
			console.log('检测到 -11880 错误（无效的采样光标）');
			showToast(`load Video Error, ${localizedDescription}`);
			// 如果是缓存文件，可能是文件损坏，删除并重新下载
			if (url && !url.startsWith('http') && !url.startsWith('https')) {
				console.log('缓存文件可能损坏，尝试使用网络URL');
				try {
					RNFS.unlink(url).catch((err: any) => {
						console.log('删除损坏的缓存文件失败:', err);
					});
				} catch (e) {
					console.log('删除文件出错:', e);
				}

				// 切换到网络URL
				if (videoUrl && (videoUrl.startsWith('http://') || videoUrl.startsWith('https://'))) {
					console.log(`缓存文件可能损坏，尝试使用网络URL ${videoUrl}`);
					setUrl(videoUrl);
					setIsNetworkUrl(true);
					setKey((prev) => prev + 1); // 强制重新加载
					setIsVideoLoaded(false);
					return;
				}
			}
		}

		errorRetryCount.current += 1;

		// 如果重试次数未超过限制，尝试切换源
		if (errorRetryCount.current <= maxRetries) {
			// 如果当前使用的是本地路径，尝试使用网络URL
			if (url === localPath || (url && !url.startsWith('http') && !url.startsWith('https'))) {
				loaclLoadError.current = true;
				// 如果有网络URL，切换到网络URL
				if (videoUrl && (videoUrl.startsWith('http://') || videoUrl.startsWith('https://'))) {
					console.log('本地文件加载失败，切换到网络URL');
					setUrl(videoUrl);
					setIsNetworkUrl(true);
					setKey((prev) => prev + 1); // 强制重新加载
					setIsVideoLoaded(false);
					return;
				}
			} else if (url === videoUrl && isNetworkUrl) {
				// 网络URL加载失败，尝试检查是否有缓存
				findCachePath(videoUrl, 'video')
					.then((cacheResult) => {
						if (cacheResult.isCache && cacheResult.url !== url) {
							console.log('网络URL加载失败，尝试使用缓存');
							// 检查缓存文件是否有效
							RNFS.stat(cacheResult.url)
								.then((stat: any) => {
									if (stat.size > 0) {
										setUrl(cacheResult.url);
										setIsNetworkUrl(false);
										setKey((prev) => prev + 1); // 强制重新加载
										setIsVideoLoaded(false);
										console.log('切换到缓存视频:', cacheResult.url);
									} else {
										console.log('缓存文件无效，继续使用网络URL');
									}
								})
								.catch(() => {
									console.log('检查缓存文件失败');
								});
						}
					})
					.catch((err) => {
						console.log('检查缓存失败:', err);
					});
			}
		} else {
			console.log('重试次数已达上限，停止重试');
			setIsBuffing(false);
		}
	}

	const saveVideo = async () => {
		if (!(await requestImage())) {
			return;
		}

		if (localPath.length > 0 && !loaclLoadError.current) {
			saveAsset(localPath);
		} else {
			saveVideoToPhoto(videoUrl);
		}
	};

	// 优化的缓冲配置 - 降低初始缓冲要求，实现快速播放
	const bufferConfig = {
		minBufferMs: 3000, // 最小缓冲时间（毫秒）- 降低以加快播放
		maxBufferMs: 15000, // 最大缓冲时间（毫秒）- 增加以支持更流畅播放
		bufferForPlaybackMs: 1000, // 开始播放所需缓冲 - 降低以更快开始播放
		bufferForPlaybackAfterRebufferMs: 2500, // 重新缓冲后所需缓冲 - 降低以更快恢复播放
	};

	function getBufferConfig() {
		return isNetworkUrl
			? {
					minBufferMs: 3000,
					maxBufferMs: 15000,
					bufferForPlaybackMs: 1000,
					bufferForPlaybackAfterRebufferMs: 2500,
			  }
			: {
					minBufferMs: 200,
					maxBufferMs: 500,
					bufferForPlaybackMs: 100,
					bufferForPlaybackAfterRebufferMs: 200,
			  };
	}

	return (
		<BaseScreen statusBarColor={black} navBarColor={black} styles={{ backgroundColor: black }}>
			<Pressable onPress={onClick} style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
				<Video
					key={key} // 使用 key 强制重新加载视频
					ref={videoRef}
					style={{ width: '100%', height: '100%' }}
					volume={1}
					fullscreenOrientation={'portrait'}
					onEnd={onEnd}
					onLoad={onLoad}
					onProgress={onProgress}
					onBuffer={onBuffer}
					onError={onError}
					onLoadStart={() => {
						// 视频开始加载时重置状态
						setIsVideoLoaded(false);
						setIsBuffing(true);
					}}
					resizeMode={'contain'}
					paused={isPause}
					playInBackground={false}
					playWhenInactive={false}
					ignoreSilentSwitch={'ignore'}
					progressUpdateInterval={250}
					// 启用缓存和优化播放
					source={{
						uri: url,
						shouldCache: isNetworkUrl, // 只在网络URL时启用缓存
						// 缓冲配置 - 优化以实现快速播放
						bufferConfig: getBufferConfig(),
					}}
					// Android特定配置
					useTextureView={false}
					// iOS特定配置
					allowsExternalPlayback={true}
				/>

				{!isVideoLoaded && thumbnailPath && (
					<FastImage
						style={{
							...StyleSheet.absoluteFillObject,
							position: 'absolute',
						}}
						resizeMode={'contain'}
						source={{ uri: thumbnailPath }}
					/>
				)}

				{isPause && <Image style={{ width: 50, height: 50, position: 'absolute' }} source={require('../assets/image/icon_play.png')} />}
			</Pressable>

			{isBuffering && !duration && (
				<ActivityIndicator
					style={{
						position: 'absolute',
						top: 0,
						bottom: 0,
						start: 0,
						end: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.7)',
					}}
					size="large"
					color="white"
				/>
			)}

			{duration && (
				<Text
					style={{
						color: white,
						marginTop: 12,
						marginStart: 12,
					}}
				>
					{secondsToHms(curTime || 0, format)} / {secondsToHms(duration || 0, format)}
				</Text>
			)}
			<Slider
				style={{ width: '100%', paddingVertical: 10 }}
				minimumValue={0}
				maximumValue={1}
				value={sliderValue}
				minimumTrackTintColor={white}
				onSlidingComplete={onSlidingComplete}
				onValueChange={onValueChange}
				maximumTrackTintColor="#CCCCCC"
				thumbTintColor={white}
			></Slider>
			<View
				style={{
					marginBottom: insets.bottom + 30,
					flexDirection: 'row',
				}}
			>
				<ImageView
					onClick={close}
					style={styles.close}
					imgStyle={{ width: 24, height: 24 }}
					source={require('../assets/image/guanbi.png')}
				/>

				<ImageView
					onClick={saveVideo}
					style={styles.close}
					imgStyle={{ width: 24, height: 24 }}
					source={require('../assets/image/icon_download.png')}
				/>
			</View>
		</BaseScreen>
	);
}
const styles = StyleSheet.create({
	close: {
		backgroundColor: 'rgba(255,255,255,0.4)',
		borderRadius: 50,
		width: 40,
		height: 40,
		justifyContent: 'center',
		alignItems: 'center',
		marginStart: 20,
	},
});
